// extracted by mini-css-extract-plugin
module.exports = {"container":"e_0q","image":"e_1q","imageImage":"e_2q","description":"e_3q","title":"e_4q","button":"e_5q"};